import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import API from '../../api/api'
import { getAssetLink } from '../../helpers/get-asset-link'

// TODO: refactor into 3 different modals
class AttendingModal extends Component {
  state = {
    selected: [],
    loading: false,
    title: '',
    message: '',
    sent: false,
    errorMessage: '',
  }

  onTitleChange = (e) => {
    e.preventDefault()
    if (e.target.value.length <= 100) this.setState({ title: e.target.value })
  }

  onMessageChange = (e) => {
    e.preventDefault()
    if (e.target.value.length <= 3000) this.setState({ message: e.target.value })
  }

  handleSend = (e) => {
    e.preventDefault()
    this.setState({ loading: true })

    const { event } = this.props
    const { title, message } = this.state
    API.notifyParticipants(event.id, { title, message })
      .then(() => this.setState({ loading: false, sent: true, title: '', message: '' }))
      .catch((error) => this.setState({ loading: false, errorMessage: error.message }))
  }

  renderNotify = () => {
    const { title, message, loading, sent, errorMessage } = this.state
    const { t } = this.props
    return (
      <div className="modal__inner ctp-popup-list">
        <section className="ctp-package vcentered autoheight">
          <div className="ctp-popup-list-data">
            <label htmlFor="title">{title !== '' ? `${title.length}/100` : ''}</label>
            <input
              type="text"
              name="title"
              value={title}
              onChange={this.onTitleChange}
              placeholder={t('calendar:attendingModal.titlePlaceholder')}
            />
          </div>
          <div className="ctp-popup-list-data">
            <label htmlFor="message">{message !== '' ? `${message.length}/3000` : ''}</label>
            <textarea
              type="text"
              name="message"
              value={message}
              onChange={this.onMessageChange}
              placeholder={t('calendar:attendingModal.messagePlaceholder')}
            />
          </div>
          {sent ? (
            <p>{t('calendar:attendingModal.messageSent')}</p>
          ) : (
            <button
              className={`button button-primary ctp-package-btn ${loading ? 'is-loading' : ''}`}
              onClick={this.handleSend}
              disabled={loading || title === '' || message === ''}
            >
              {t('calendar:attendingModal.send')}
            </button>
          )}
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </section>
      </div>
    )
  }

  renderFile = () => {
    const { event } = this.props
    return (
      <div className="modal__inner ctp-popup-list">
        <section className="ctp-package vcentered autoheight">
          <object
            data={
              event.file && event.file.includes('data:application/pdf;')
                ? event.file
                : getAssetLink({
                    path: 'chitown-images/training',
                    file: event.file,
                    fallback: { file: 'training_image.png' },
                  })
            }
            type="application/pdf"
            width="600"
            height="700"
          />
        </section>
      </div>
    )
  }

  closePopup = (e) => {
    this.setState({
      selected: [],
      sent: false,
      errorMessage: '',
      title: '',
      message: '',
    })
    this.props.closePopup(e)
  }

  render() {
    const { isOpen, type, event, t } = this.props

    return (
      <div className={`modal modal--organisation ${isOpen ? 'is-active' : ''}`}>
        <div className="modal-background" onClick={this.closePopup} />
        <div className="modal-content" style={{ width: '800px' }}>
          <div className="box">
            <header className="modal__header">
              {type === 'notify' && (
                <span>{t('calendar:attendingModal.notifyFor', { title: event.title })}</span>
              )}
              {type === 'file' && <span>{t('calendar:attendingModal.information')}</span>}
              <button
                className="modal-close is-large"
                aria-label="close"
                onClick={this.closePopup}
                style={{ marginRight: '10px' }}
              />
            </header>
            {type === 'notify' && this.renderNotify()}
            {type === 'file' && this.renderFile()}
          </div>
        </div>
      </div>
    )
  }
}

AttendingModal.propTypes = {
  event: PropTypes.object,
  isOpen: PropTypes.bool,
  closePopup: PropTypes.func,
  type: PropTypes.string,
  t: PropTypes.func,
}

export default withTranslation(['calendar'])(AttendingModal)
